import React from "react";

interface IFormInputNumberProps {
  label: string;
  id: string;
  value?: string | number | undefined;
  hint?: string | undefined;
  required?: boolean | undefined;
  placeholder?: string | undefined;
  step?: number;
  onChange: (id: string, value: string) => void;
  error?: string | undefined;
}

function FormInputNumber({
  label,
  id,
  value,
  hint,
  required,
  placeholder,
  step = 1,
  onChange,
  error,
}: IFormInputNumberProps) {
  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <input
        type="number"
        name={id}
        id={id}
        value={value}
        className="form-input"
        placeholder={placeholder}
        required={required}
        step={step}
        onChange={(e) => onChange(id, e.target.value)}
      />
      {hint && <div className="form-hint">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputNumber;
